<template>
  <div class="flex flex-col p-4">
    <form-item label="Search">
      <Input v-model="filter" placeholder="Search Artist name" />
    </form-item>
    <div class="flex w-full mb-3">
      <Button variant="primary" class="w-full" label="Search" @clicked="search" />
    </div>
    <data-tables-server ref="tableArtist" :data="list" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
      <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
      </el-table-column>
      <el-table-column label="Actions" align="right" min-width="100px">
        <template slot-scope="scope">
          <div class="static inline-block text-left container-action">
            <VueCustomTooltip :label="!scope.row.added?'Add':'Remove'" :position="'is-left'">
              <button v-if="!scope.row.added" @click="addArtistTo(scope.row,true)" class="p-2 rounded bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon :icon="['fa', 'plus']" /> Add
              </button>
              <button v-if="scope.row.added" @click="addArtistTo(scope.row,false)" class="p-2 rounded bg-blue-100 text-blue-700 hover:bg-blue-700 hover:text-blue-100 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon  :icon="['fa', 'check']" /> Remove
              </button>
            </VueCustomTooltip>
          </div>
        </template>
      </el-table-column>
    </data-tables-server>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import helpersMixin from '../../mixins/helpers.mixins';
import moment from 'moment/moment';
import Button from '@/components/Layout/Form/Button.vue';
import { FormItem, Input } from '@/components/Layout/Form';

export default {
  name: 'SearchArtist',
  mixins: [helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    takenArtist: {
      type: Array | [],
      default: () => [],
    },
  },
  data() {
    return {
      addArtist: [],
      displayingItem: 20,
      list: [],
      total: 0,
      titles: [{
        prop: {
          field: 'name',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'email',
        },
        label: 'Email',
      }],
      filter: '',
    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('AuthModule', ['tokenType', 'accessToken']),
    ...mapGetters('ArtistModule', ['listArtist']),
  },
  watch: {
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetState();
        }
      },
    },
    listArtist: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listArtist.data != undefined) {
          this.total = this.listArtist.data.total;
          this.list = this.listArtist.data.data.map(artist => ({ ...artist, added: this.isExist(artist.id) }));
        }
      },
    },
  },
  async mounted() {
    this.total = 0;
    this.list = [];
  },
  methods: {
    ...mapActions('ArtistModule', ['requestListArtist']),
    resetState() {
      this.addArtist = [...this.takenArtist];
      this.list = [];
      this.total = 0;
      this.filter = '';
    },
    async searchArtist(page) {
      // eslint-disable-next-line max-len
      await this.requestListArtist({ page, per_page: this.displayingItem, q: this.filter });
    },
    async search() {
      await this.searchArtist(1);
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      await this.requestListArtist({ per_page: this.displayingItem, q: this.filter, sortorder, sortby, page });
    },
    isExist(id) {
      return this.addArtist.findIndex(song => song.id === id) !== -1;
    },
    addArtistTo(row, status) {
      row.added = status;
      if (status) {
        const newRow = { ...row };
        this.addArtist.push(newRow);
      } else {
        this.$emit('on-remove-artist', row.id);
        const index = this.addArtist.findIndex(song => song.id === row.id);
        this.addArtist.splice(index, 1);
      }
    },
    submit() {
      this.$emit('on-submit-artist', this.addArtist);
    },
  },
  components: { Button, FormItem, Input }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AppSetting/SearchArtist.vue